module.exports = __webpack_public_path__ + "img/bulk-cargo.a6f56f32.jpg";